import classNames from 'classnames';
import React from 'react';

export interface IBackLink {
  className?: string;
  primaryText: string | React.ReactNode;
  secondaryText?: string;
  tertiaryText?: string;
  loadingText?: string;
  primaryClassName?: string;
  secondaryClassName?: string;
  tertiaryClassName?: string;
  loadingClassName?: string;
  secondaryCondition?: boolean;
  tertiaryCondition?: boolean;
  loadingCondition?: boolean;
}

export const PageTitle: React.FC<IBackLink> = ({
  className,
  primaryText,
  secondaryText,
  tertiaryText,
  loadingText,
  primaryClassName = '',
  secondaryClassName = '',
  tertiaryClassName = '',
  loadingClassName = '',
  secondaryCondition,
  tertiaryCondition,
  loadingCondition,
}) => {
  return (
    <div className={classNames('page-title font-noe-display flex items-baseline', className)}>
      <h1
        className={classNames(
          'primary-title font-noe-display text-4xl leading-46px text-black font-normal m-0',
          primaryClassName
        )}
      >
        {primaryText}
      </h1>
      {secondaryCondition && (
        <h2
          className={classNames(
            'secondary-title font-noe-display text-26px leading-33px text-black font-normal m-0 ml-5px',
            secondaryClassName
          )}
        >
          &nbsp;{secondaryText}
        </h2>
      )}
      {tertiaryCondition && tertiaryText && (
        <h2
          className={classNames(
            'tertiary-title font-noe-display text-26px leading-33px text-gray-100 font-normal m-0 ml-5px',
            tertiaryClassName
          )}
        >
          &nbsp;{tertiaryText}
        </h2>
      )}
      {loadingCondition && (
        <h2
          className={classNames(
            'secondary-title font-noe-display text-26px leading-33px text-black font-normal m-0 ml-5px',
            loadingClassName
          )}
        >
          &nbsp;{loadingText}
        </h2>
      )}
    </div>
  );
};
